import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/consumer-spend.png'

const DemographicsConsumerSpend = dynamic(() => import('src/components/insights/demographics/cards/consumer-spend'), {
  ssr: false,
})

export const DemographicsConsumerSpendWidget: InsightBuilderWidget = {
  id: 'consumer-spend',
  name: 'Consumer Spend',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsConsumerSpend,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
